import { Diagnostic } from "@siteimprove/alfa-act";
import { Node } from "@siteimprove/alfa-aria";
/**
 * @public
 */
export class WithRole extends Diagnostic {
    static of(message, role) {
        return role === undefined
            ? new Diagnostic(message)
            : new WithRole(message, role);
    }
    _role;
    constructor(message, role) {
        super(message);
        this._role = role;
    }
    get role() {
        return this._role;
    }
    equals(value) {
        return (value instanceof WithRole &&
            value._message === this._message &&
            value._role === this._role);
    }
    hash(hash) {
        super.hash(hash);
        hash.writeString(this._role);
    }
    toJSON(options) {
        return {
            ...super.toJSON(options),
            role: this._role,
        };
    }
}
/**
 * @public
 */
(function (WithRole) {
    function isWithRole(value) {
        return value instanceof WithRole;
    }
    WithRole.isWithRole = isWithRole;
    function getRoleName(element, device) {
        return Node.from(element, device)
            .role.map((role) => role.name)
            .getOr("generic");
    }
    WithRole.getRoleName = getRoleName;
})(WithRole || (WithRole = {}));
//# sourceMappingURL=with-role.js.map